import createGetFormAsyncErrors from './selectors/getFormAsyncErrors';
import plain from './structure/plain';

export default createGetFormAsyncErrors(plain);


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/es/getFormAsyncErrors.js
// module id = 1513
// module chunks = 0